const initialState = {
  siteLoggingIntervals: JSON.parse(localStorage.getItem('redux_sync_SiteLoggingIntervals')) || [],
  fetching: false,
  fetched: false,
  error: null,
}

export default function reducer(state = initialState, action) {

  let payloadData

  switch (action.type) {
    case "SITE_LOGGING_INTERVALS_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case "SITE_LOGGING_INTERVALS_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "SITE_LOGGING_INTERVALS_FETCH_FULFILLED":
      payloadData = action.payload.data
      localStorage.setItem('redux_sync_SiteLoggingIntervals',JSON.stringify(payloadData))
      return {
        ...state,
        fetching: false,
        fetched: true,
        siteLoggingIntervals: payloadData,
        errors: null,
      }
    case  'USER_SIGN_OUT_PENDING':
      localStorage.removeItem('redux_sync_SiteLoggingIntervals')
      return {
        ...initialState,
        siteLoggingIntervals: [],
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState,
        siteLoggingIntervals: [],
      }
    default:
      return state
  }

}



// WEBPACK FOOTER //
// ./src/reducers/siteLoggingIntervalsReducer.js